import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { ExportStatusService } from './export-status.service';

@Component({
  selector: 'app-export-banner',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './export-banner.component.html',
  styleUrl: './export-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportBannerComponent {
  protected readonly exportStatus = inject(ExportStatusService);

  protected onRetry(): void {
    this.exportStatus.retry();
  }

  protected onRedownload(): void {
    this.exportStatus.redownload();
  }
}
